<div class="conciliation-monitor-compact">

  <!-- Empty State: No hay proceso en ejecución -->
  <div *ngIf="!progressData && !isProcessing" class="dd-empty">
    <div class="dd-empty__ico">
      <i class="fas fa-hourglass-start"></i>
    </div>
    <h3 class="dd-empty__title">
      Sin proceso de conciliación activo
    </h3>
    <p class="dd-empty__text">
      La información de progreso se mostrará aquí cuando se inicie el proceso de conciliación de este lote.
    </p>
  </div>

  <!-- Buscando trace... -->
  <div *ngIf="!progressData && isProcessing" class="dd-empty">
    <div class="dd-empty__ico">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
    <p class="dd-empty__text">Buscando información del proceso...</p>
  </div>

  <!-- Vista En Progreso (PENDING) -->
  <div *ngIf="progressData && progressData.state === 'PENDING'">

    <!-- Barra de Progreso -->
    <div class="progress-section">
      <div class="progress-info">
        <span><strong>{{ progressData.progress?.processed || 0 }}</strong> de <strong>{{ progressData.progress?.total || 0 }}</strong> pagos</span>
        <span><strong>{{ progressData.progress?.percentage || 0 }}%</strong></span>
      </div>
      <div class="progress-bar">
        <div class="progress-fill-success"
             [style.width.%]="progressData.progress?.percentage || 0">
        </div>
      </div>
    </div>

    <!-- Estadísticas del Proceso -->
    <div class="stats">
      <div class="stat success">
        <span class="icon"><i class="fas fa-check-circle"></i></span>
        <span class="value">{{ progressData.progress?.processed }}</span>
        <span class="label">Procesados</span>
      </div>
      <div class="stat skipped">
        <span class="icon"><i class="fas fa-forward"></i></span>
        <span class="value">{{ progressData.progress?.skipped }}</span>
        <span class="label">Omitidos</span>
      </div>
      <div class="stat error">
        <span class="icon"><i class="fas fa-times-circle"></i></span>
        <span class="value">{{ progressData.progress?.failed }}</span>
        <span class="label">Fallidos</span>
      </div>
    </div>

    <!-- Último Pago Procesado -->
    <div class="last-payment" *ngIf="progressData.last_payment && shouldShowLastPayment()" [class.warning]="isLastPaymentStale()">
      <div class="last-payment-header">
        <span class="icon"><i class="fas fa-credit-card"></i></span>
        <span>Último pago procesado</span>
      </div>
      <div class="last-payment-info">
        <div class="payment-detail">
          <strong>Referencia:</strong> {{ progressData.last_payment.reference }}
        </div>
        <div class="payment-detail">
          <strong>Hace:</strong> {{ getTimeSinceLastPayment() }}
        </div>
      </div>
      <div class="stale-warning" *ngIf="isLastPaymentStale()">
        Ha pasado mucho tiempo desde que se procesó el último pago y no se ha completado el proceso.
        Si se requiere, se puede reiniciar el proceso para continuar.
      </div>
    </div>

    <!-- Fase Actual y Countdown -->
    <div class="phase-info">
      <div class="phase-text">
        <span class="phase-icon"><i class="fas fa-map-marker-alt"></i></span>
        <span>{{ progressData.current_phase?.description }}</span>
      </div>
      <div class="countdown-text">
        Actualiza en {{ countdown }}s
      </div>
    </div>

  </div>

  <!-- Vista Completada -->
  <div *ngIf="progressData && progressData.state === 'COMPLETE'" class="completed">
    <div class="success-icon"><i class="fas fa-check"></i></div>
    <h3>Conciliación Completada</h3>
    <p>{{ progressData.progress?.successful }} pagos procesados exitosamente</p>

    <div class="final-stats">
      <div><strong>Total:</strong> {{ progressData.progress?.total }}</div>
      <div><strong>Exitosos:</strong> {{ progressData.progress?.successful }}</div>
      <div><strong>Fallidos:</strong> {{ progressData.progress?.failed }}</div>
      <div><strong>Omitidos:</strong> {{ progressData.progress?.skipped }}</div>
    </div>
  </div>

  <!-- Vista Error -->
  <div *ngIf="progressData && progressData.state === 'ERROR'" class="error-view">
    <div class="error-icon"><i class="fas fa-times-circle"></i></div>
    <h3>Error en la Conciliación</h3>
    <p>{{ progressData.current_phase?.description }}</p>
  </div>

  <!-- Vista Cancelada -->
  <div *ngIf="progressData && (progressData.state === 'CANCELLED' || progressData.state === 'CANCELLED_MULTIPLE_EXECUTION')" class="cancelled-view">
    <div class="cancelled-icon"><i class="fas fa-ban"></i></div>
    <h3>Proceso Cancelado</h3>
    <p>{{ progressData.current_phase?.description || 'El proceso fue cancelado por el usuario' }}</p>
  </div>

</div>
